<template>
    <div>
        <b-modal v-model="visible" 
            no-close-on-backdrop no-close-on-esc hide-header 
            button-size="lg" 
            footer-class="justify-content-center" 
            ok-title="Ja, jeg er fyldt 18 år" 
            @ok="ok"
            @cancel="deny"
            @close="deny"
            cancel-title="Nej">
                <h2>Du skal være minimum 18 år for at handle i denne webshop</h2>
                <h4 class="my-4">I henhold til dansk lovgivning, sælger vi ikke alkohol til personer under 18 år, hvorfor du skal bekræfte din alder.
        Vi gør opmærksom på, at vi kan kræve billedlegitimation, hvis vi er i tvivl om, at du som kunde opfylder aldersgrænsen.</h4>
                <h2 class="text-center">Er du fyldt 18 år?</h2>
        </b-modal>
        <b-modal v-model="showByeMsg" no-close-on-backdrop no-close-on-esc hide-footer hide-header>
            <h1>Du må desværre ikke fortsætte på denne side</h1>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue'
export default {
    data(){
        return {
            visible:true,
            showByeMsg : false
        }
    },
    methods:{
        deny(){
            this.showByeMsg = true;
        },
        ok(){
            var endDate = new Date();
            endDate.setDate(new Date().getDate() + 1)
            document.cookie = "hideAgeWarning1Day=true; expires=" + endDate.toUTCString() + "; path=/";
            this.visible = false;
        }
    },
    created(){
        this.visible = document.cookie.indexOf("hideAgeWarning1Day")<0;
    }
}
</script>